import React, { useCallback } from 'react'

import cx from 'classnames'
import Badge from 'conversations/components/Badge'
import { Inbox } from 'shared/typings/bootstrap'
import { useDebounce } from 'use-debounce'

import styles from './styles.module.css'

interface Props {
  onClick: (inbox: Inbox | null) => void
  count: number
  isSelected: boolean
  name: string
  dataInbox: Inbox | null
  badgeCount: number
}

const InboxSwitcherItem: React.FC<Props> = ({
  name,
  onClick,
  count,
  isSelected,
  dataInbox,
  badgeCount,
}): JSX.Element => {
  const setInbox = useCallback(() => onClick(dataInbox), [dataInbox, onClick])
  const [debouncedCount] = useDebounce(badgeCount, 750)

  return (
    <div
      onClick={setInbox}
      className={cx(styles.inboxSwitcherItem, { [styles.selected]: isSelected })}>
      <div className={styles.inboxName}>{name}</div>
      {debouncedCount > 0 ? <Badge count={debouncedCount} /> : <div>{count}</div>}
    </div>
  )
}

export default InboxSwitcherItem
